import { Switch, View } from "react-native";
import { withUnistyles } from "react-native-unistyles";

import Text from "$src/core/components/atoms/Text/Text";

import $ from "./Toggle.styles";
import type { ToggleProps } from "./types";

const UniSwitch = withUnistyles(Switch, ({ colors }) => ({
  trackColor: {
    false: colors.backgroundSurface,
    true: colors.backgroundPositive,
  },
  thumbColor: colors.foregroundDefault,
  activeThumbColor: colors.foregroundDefault,
}));

const Toggle: React.FC<ToggleProps> = ({
  label,
  description,
  value = false,
  disabled = false,
  onChange,
}) => (
  <View style={[$.container, disabled && $.disabled]}>
    <View style={$.content}>
      <Text accessibilityRole="text" preset="heading6">
        {label}
      </Text>
      {typeof description === "string" ? (
        <Text accessibilityRole="text" preset="tiny" style={$.description}>
          {description}
        </Text>
      ) : (
        description
      )}
    </View>
    <View style={$.control}>
      <UniSwitch
        disabled={disabled}
        onValueChange={(next) => onChange?.(next)}
        value={value}
      />
    </View>
  </View>
);

export default Toggle;
